import { BoxProps } from "@zenchef/styled-system/jsx";
import { ElementRef, forwardRef } from "react";
import { IconName } from "@zenchef/icomoon/dist/aromaticons/types";
import {
  MessageBubbleRoot,
  MessageBubbleContent,
  MessageBubbleRootProps,
} from "./messageBubbleParts";

export interface MessageBubbleProps
  extends Omit<MessageBubbleRootProps, "type">,
    BoxProps {
  children: React.ReactNode;
  icon?: IconName;
}

const MessageBubble = forwardRef<ElementRef<"div">, MessageBubbleProps>(
  ({ children, icon, colorTheme, ...props }, ref) => {
    return (
      <MessageBubbleRoot type={colorTheme} {...props} ref={ref}>
        <MessageBubbleContent icon={icon} colorTheme={colorTheme}>
          {children}
        </MessageBubbleContent>
      </MessageBubbleRoot>
    );
  },
);

MessageBubble.displayName = "MessageBubble";

export default MessageBubble;
